import { render, staticRenderFns } from "./TixstockTrendingCategories.vue?vue&type=template&id=909417bc&scoped=true"
import script from "./TixstockTrendingCategories.vue?vue&type=script&lang=js"
export * from "./TixstockTrendingCategories.vue?vue&type=script&lang=js"
import style0 from "./TixstockTrendingCategories.vue?vue&type=style&index=0&id=909417bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909417bc",
  null
  
)

export default component.exports